export const SET_REMITTANCE = "SET_REMITTANCE";
export const SET_REMITTANCES = "SET_REMITTANCES";
